import Vue from 'vue'
import Router from 'vue-router'
import i18n from '@/i18n'

Vue.use(Router)

/* Layout */
import Layout from '@/layout'
// 公共路由
export const constantRoutes = [
    //首页
    {
        path: '/',
        component: Layout,
        redirect: '/index',
        hidden: true,
        children: [
            {
                path: 'index',
                component: () => import('@/views/index/index'),
                name: 'Index',
                meta: {title: i18n.t('dashboard')}//'首页'
            },
            {
                path: 'about',
                component: () => import('@/views/about/index'),
                name: 'About',
                meta: {title: i18n.t('guan-yu-qian-jing')},//'关于乾景
            },
            {
                path: '/develop',
                component: () => import('@/views/develop/index'),
                name: 'Develop',
                meta: {title: i18n.t('ke-chi-xu-fa-zhan')}//可持续发展
            },
            {
                path: '/news',
                component: () => import('@/views/news/index'),
                name: 'News',
                meta: {title: i18n.t('xin-wen-zhong-xin')}//新闻中心
            },
            {
                path: '/news/detail/:id/',
                component: () => import('@/views/news/detail'),
                name: 'NewsDetail',
                hidden: true,
                meta: {title: i18n.t('xin-wen-xiang-qing')}//新闻详情
            },
            {
                path: '/contact',
                component: () => import('@/views/contact/index'),
                name: 'Contact',
                meta: {title: i18n.t('lian-xi-wo-men')}//联系我们
            }
        ]
    },
    {
        name: 'ProductService',
        path: '/productService',
        hidden: true,
        component: Layout,
        meta: {title: i18n.t('chan-pin-yu-fu-wu')},//产品与服务
        children: [
            {
                name: 'Product',
                path: 'product',
                component: () => import('@/views/productService/product/index'), // 需要创建这个组件
                meta: {title: i18n.t('chan-pin'), noView: true},//产品
                hidden: true,
                children: [
                    {
                        name: 'Lifting',
                        path: 'lifting', // 相对路径
                        hidden: true,
                        component: () => import('@/views/productService/product/lifting/index'), // 需要创建这个组件
                        meta: {title: i18n.t('ren-gong-ju-sheng-xi-tong'), noView: true},//人工举升系统
                        // redirect: '/productService/product/lifting/electricPump',
                        children: [
                            {
                                name: 'ElectricPump',
                                path: 'electricPump', // 相对路径
                                component: () => import('@/views/productService/product/lifting/electricPump/index'),
                                meta: {
                                    title: i18n.t('dian-qian-luo-gan-beng'),//'电潜螺杆泵'
                                }
                            },
                            {
                                name: 'MachinePump',
                                path: 'machinePump', // 相对路径
                                hidden: true,
                                component: () => import('@/views/productService/product/lifting/electricPump/detail/machinePump'),
                                meta: {
                                    title: i18n.t('ji-bao-beng'),//'机-保-泵',
                                },
                            },
                            {
                                name: 'Sensor',
                                path: 'sensor', // 相对路径
                                hidden: true,
                                component: () => import('@/views/productService/product/lifting/electricPump/detail/sensor'),
                                meta: {
                                    title: i18n.t('jing-xia-chuan-gan-qi'),//'井下传感器'
                                },
                            },
                            {
                                name: 'ControlCabinet',
                                path: 'controlCabinet', // 相对路径
                                hidden: true,
                                component: () => import('@/views/productService/product/lifting/electricPump/detail/controlCabinet'),
                                meta: {
                                    title: i18n.t('kong-zhi-gui'),//控制柜
                                },
                            },
                        ]
                    },
                    {
                        name: 'Support',
                        path: 'support',
                        meta: {title: i18n.t('pei-tao-fu-jian')},//配套辅件
                        component: () => import('@/views/productService/product/support/index'),
                    },
                    {
                        name: 'Energy',
                        path: 'energy',
                        meta: {title: i18n.t('neng-yuan-fang-an')},//能源方案
                        component: () => import('@/views/productService/product/energy/index')
                    },
                ]
            },
            {
                name: 'Service',
                path: 'service',
                hidden: true,
                meta: {title: i18n.t('fu-wu')},//服务
                component: () => import('@/views/productService/service/index'),
                children: [
                    {
                        name: 'Application',
                        path: 'application',
                        meta: {title: i18n.t('ying-yong-fang-an')},//应用方案
                        component: () => import('@/views/productService/service/application')
                    },
                    {
                        name: 'ServiceDetail',
                        path: 'service',
                        mmeta: {title: i18n.t('fu-wu')},//服务
                        component: () => import('@/views/productService/service/service')
                    },
                ]
            }
        ]
    },
    {
        path:'*',
        redirect: '/'
    }
]

// 防止连续点击多次路由报错
let routerPush = Router.prototype.push;
let routerReplace = Router.prototype.replace;
// push
Router.prototype.push = function push(location) {
    return routerPush.call(this, location).catch(err => err)
}
// replace
Router.prototype.replace = function push(location) {
    return routerReplace.call(this, location).catch(err => err)
}

export default new Router({
    mode: 'history', // 去掉url中的#
    scrollBehavior: () => ({y: 0}),
    routes: constantRoutes
})
//全局路由守卫:自动更新页面标题和meta信息
// router.beforeEach((to, from, next) => {
//     if (
//         to.meta.title
//     ) {
//         document.title = to.meta.title;
//     }
//     next();
// })
